<template>
    <div class="portal">
        <div class="container banner" :style="{ backgroundImage: `url(${pageParams.pageBg})` }">
            <div class="content">
                <Banner :title="pageParams.pageTitle" label="" />
            </div>
        </div>
        <div class="container">
            <div class="content" style="padding-top: 0">
                <Entrance :classify-map="classifyMap" />
            </div>
        </div>
        <div class="container">
            <div class="content">
                <Notice title="科研动态" />
            </div>
        </div>
        <div class="container" :style="{ backgroundImage: `url(${pageParams.projectBg})` }">
            <div class="content">
                <Subject title="科研项目" />
            </div>
        </div>
        <!-- <div class="container">
            <div class="content">
                <Activity title="科研活动" />
            </div>
        </div> -->
        <div class="container" :style="{ backgroundImage: `url(${pageParams.achievementBg})` }">
            <div class="content">
                <Result title="科研成果" />
            </div>
        </div>
    </div>
</template>

<script setup>
import Banner from './components/banner.vue';
import Notice from './part/notice.vue';
import Result from './part/result.vue';
import Subject from './part/subject.vue';
import Activity from './part/activity.vue';
import Entrance from './part/entrance.vue';
import { computed, ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import pageImg from '@/assets/img/portal/banner.png';

const store = useStore();

// 全部备案信息
const brand = computed(() => {
    return store.state.brand?.publishBrand || {};
});

// 具体备案信息
const brandInfo = computed(() => {
    return brand.value?.brandConfig || {};
});

const pageParams = ref({
    pageBg: pageImg,
    pageTitle: '教育科研管理平台',
    projectBg: '',
    achievementBg: '',
});

const classifyList = ref([]);

const classifyMap = ref({});

function getPageSetting() {
    G_transmit('scPageSetting', {
        queries: {
            modelType: 'home',
        },
    }).then(res => {
        if (res.data) {
            pageParams.value = JSON.parse(res.data);
            if (!pageParams.value.pageBg) {
                pageParams.value.pageBg = pageImg;
            }
        }
    });
}

function getClassify() {
    G_transmit('escHomeGetProjectType', {}).then(res => {
        classifyList.value = res?.data || [];
        classifyList.value.forEach(item => {
            classifyMap.value[item.code] = item.name;
        });
    });
}

onMounted(() => {
    getClassify();
    getPageSetting();
});
</script>

<style lang="scss" scoped>
.portal {
    display: flex;
    flex-flow: column;
    min-height: 100%;
    .container {
        display: flex;
        justify-content: center;
        background: #ffffff;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
        &.banner {
            padding: 60px 0 130px;
        }
    }
    .content {
        gap: 24px;
        display: flex;
        flex-flow: column;
        position: relative;
        max-width: 100%;
        padding: 40px 0 48px;
        width: 1200px;
    }
    .entrance {
        position: absolute;
        top: -100px;
        left: 0;
        width: 100%;
    }
}
</style>
